<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb :items="breadcrumb" visible-button />
    </template>
    <v-row class="containerProposalList">
      <BaseTab
        class="proposalList__tab px-0 mx-0"
        :value="currentTab"
        @change="currentTab = $event"
      >
        <v-row>
          <v-col cols="auto" class="proposalList__col">
            <v-tab>PROPOSTAS</v-tab>
          </v-col>
          <v-spacer class="d-none d-sm-flex" />
        </v-row>
        <v-tab-item class="pt-5">
          <ProposalTable />
        </v-tab-item>
        <v-tab-item class="pt-5">
          <InvoiceTable />
        </v-tab-item>
      </BaseTab>
    </v-row>
  </Main>
</template>
<script>
import ProposalTable from "../components/ProposalTable";
export default {
  name: "ProposalList",
  data: () => ({
    breadcrumb: [
      {
        text: "Propostas",
        to: "quotation element"
      }
    ],
    currentTab: 0
  }),
  components: {
    ProposalTable
  },
  computed: {
    firstTab() {
      return this.currentTab == 0;
    }
  },
  mounted() {
    this.currentTab = this.$route.params.currentTab ?? 0;
  }
};
</script>
<style lang="sass">
.containerProposalList
  width: 100% !important
  margin: 0 auto !important
.proposalList__
  &col
    align-self: center
  &tab
    .v-tabs-bar
      height: 50px !important
</style>
